<template>
  <transition name="popup-fade">
    <div
      v-if="visible"
      class="absolute inset-0 flex items-center justify-center bg-[rgba(1,36,94,0.75)] z-50"
    >
      <div
        class="flex popup items-start justify-center z-50 rounded-xl p-[3px]!"
        :class="textStyle === 'bubbles' ? 'gold-border-wrapper' : 'white-border-wrapper'"
        aria-hidden="false"
      >
        <div
          class="text-white rounded-xl px-6 py-2 max-w-[28rem] w-full text-center"
          :class="textStyle === 'bubbles' ? 'bg-primary' : 'bg-accent'"
          role="status"
        >
          <div class="text-3xl font-bold text-white uppercase leading-none">
            {{ topText }}
          </div>
          <div
            class="text-5xl uppercase font-extrabold leading-none"
            :class="textStyle === 'bubbles' ? 'bubbles-text-background' : 'text-white'"
          >
            {{ bottomText }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  popupType: {
    type: String,
    default: '',
  },

  visible: {
    type: Boolean,
    default: false,
  },
});

const popups = {
  treble20: {
    top: 'Treble',
    bottom: 'Twenty',
    style: 'bubbles',
  },
  doubleTop: {
    top: 'Double',
    bottom: 'Top',
    style: 'bubbles',
  },
  downUnderCheckout: {
    top: 'Down Under',
    bottom: 'Checkout',
    style: 'bubbles',
  },
  bullseye: {
    top: 'BBBBBBBBB',
    bottom: 'Bullseye',
    style: 'bubbles',
  },
  oneHundredAndEighty: {
    top: 'One Hundred and',
    bottom: 'Eighty!!!',
    style: 'bubbles',
  },
  theBigFish: {
    top: 'The',
    bottom: 'Big Fish!',
    style: 'bubbles',
  },
  classic26: {
    top: 'Classic',
    bottom: '26!',
    style: 'bubbles',
  },
  busted: {
    top: 'Well and Truly',
    bottom: 'Busted',
    style: 'red',
  },
  downUnderDouble: {
    top: 'Down Under',
    bottom: 'Double',
    style: 'bubbles',
  },
};

const topText = computed(() => popups[props.popupType]?.top);
const bottomText = computed(() => popups[props.popupType]?.bottom);
const textStyle = computed(() => popups[props.popupType]?.style);
</script>

<style scoped>
.popup-fade-enter-active,
.popup-fade-leave-active {
  transition: opacity 200ms ease;
}
.popup-fade-enter-from,
.popup-fade-leave-to {
  opacity: 0;
}
.popup-fade-enter-to,
.popup-fade-leave-from {
  opacity: 1;
}

.popup-fade-enter-active .popup,
.popup-fade-leave-active .popup {
  animation: bounce-in 0.4s ease-out forwards;
  transform-origin: center;
}
.popup-fade-enter-from .popup,
.popup-fade-leave-to .popup {
  animation: bounce-in 0.4s ease-out forwards;
  transform-origin: center;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.1);
  }
  60% {
    transform: scale(1.3);
  }
  80% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

.popup {
  font-family: Montserrat, sans-serif;
}
</style>
